import styled from 'styled-components'

export const Container = styled.div`
  .description {
    margin-top: 15px;
  }
`
